import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular';
import { environment } from '@app/env';
import { version } from '../package.json';

Sentry.init(
  {
    dsn: environment.sentryDsn,
    environment: environment.envName,
    release: `myjobfixers@${version}`,
    enabled: !!environment.sentryDsn && environment.envName !== 'dev',
    sendDefaultPii: false,
  },
  SentryAngular.init
);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
